exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".date-range-slider[data-v-0cfccb24] {\n  background-color: #abbbbe;\n  height: 4.5rem;\n  margin: 0.5rem 0 1rem;\n}\n.date-range-slider .custom-tooltip[data-v-0cfccb24] {\n  font-size: 0.875rem;\n}", ""]);

// exports
